import { render, staticRenderFns } from "./player-mascot-registration.vue?vue&type=template&id=5f815aea&scoped=true&lang=pug"
import script from "./player-mascot-registration.vue?vue&type=script&setup=true&lang=js"
export * from "./player-mascot-registration.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./player-mascot-registration.vue?vue&type=style&index=1&id=5f815aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f815aea",
  null
  
)

export default component.exports